import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetAgentChat } from './useGetAgentChat'
import { AgentChatContent } from './AgentChatContent'

export const AgentChatComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetAgentChat(id, tileFilterSelections)

  return (
    <AgentChatContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function AgentChatComponentLoading() {
  return 'Loading...'
}
